// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_fa-0";